import { Injectable } from '@angular/core';
import { Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CMSPortalEndpoints } from './cms-portal.endpoints';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';

import { Origem } from '../model/origem.model';
import { Response } from '../model/response.model';
import { ErrorHandler } from '../../../app.error-handler';
import { RespostaPergunta } from '../model/resposta-pergunta.model';
import { Pesquisa } from '../model/pesquisa.models';

@Injectable({
    providedIn: 'root'
})
export class CMSPortalService {

    constructor(private http: HttpClient,
                private endpoints: CMSPortalEndpoints,
                @Inject('BASE_URL') private url: string) {
    }

    getESM(): Observable<Origem> {
        return this.http.get<Origem>(this.url + this.endpoints.cadastrobasico_getESM())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getLogo(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.bancoimagem_recuperaUltimaLogoPublicada())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getSlideNoticia(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.divulgacao_buscarSlideNoticias())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getDestaquesNoticias(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.divulgacao_buscarDestaquesNoticias())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getDestaqueImagem(max: Number): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.bancoimagem_recuperaDestaqueImagem(max))
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getMenuSite(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.site_buscarMenu())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getPagina(idPagina: string): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.site_buscarPagina(idPagina))
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getNoticias(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.divulgacao_listarNoticia())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getUltimaNoticia(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.divulgacao_buscarUltimaNoticias())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getNoticia(idNoticia: string): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.divulgacao_buscarNoticia(idNoticia))
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getVideos(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.bancoimagem_recuperaVideos())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getVideo(idVideo: string): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.bancoimagem_recuperaVideo(idVideo))
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getSlideEvento(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.eventos_buscarSlideEventos())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getEventos(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.eventos_buscarEventos())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getEvento(idEvento: string): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.eventos_buscarEvento(idEvento))
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getEnquete(): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.formulario_buscarEnquete())
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    salvarVotoEnquete(resposta: RespostaPergunta): Observable<Response> {
        const httpHeaders = new HttpHeaders({
            'Content-Type' : 'application/json'
        });
        const options = {
            headers: httpHeaders
        };
        return this.http.post<Response>(this.url + this.endpoints.formulario_salvarPerguntaEnquete(), resposta, options)
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    getResultadoEnquete(idSecao: string): Observable<Response> {
        return this.http.get<Response>(this.url + this.endpoints.formulario_buscarResultadoPerguntaEnquete(idSecao))
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

    realizarPesquisa(texto: string): Observable<Response> {
        const pesquisa = new Pesquisa(texto, this.endpoints._idSetor);
        const httpHeaders = new HttpHeaders({
            'Content-Type' : 'application/json'
        });
        const options = {
            headers: httpHeaders
        };
        return this.http.post<Response>(this.url + this.endpoints.site_efetuarPesquisa(), pesquisa, options)
            .pipe(
                catchError(e => ErrorHandler.handleError(e))
            );
    }

}
